import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { forceCheck } from 'react-lazyload'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { calculateDeckPriceData } from '../../../helper/prices'
import { LegalInfoFlyOut, StatsItem, StatsLabel } from '../Toolbar'
import translate from '../../../helper/translate'
import FlyoutDeckPrice from '../FlyoutDeckPrice'
import priceSources, { priceSourceCurrencies } from '../../../data/priceSources'
import { mobile } from '../../../styles/media'
import { formatCurrency } from '../../../helper/string'

const StatsDeckPrice = ({ deckCards, deckSlug, loading, location, onClick, priceSource, t }) => {
	const { priceTotal } = calculateDeckPriceData(deckCards)
	const currency = priceSourceCurrencies[priceSource]

	const ref = useRef(undefined)

	useEffect(() => {
		if (location.pathname !== `/deck/${deckSlug}`) {
			ref.current.scrollTo(0, 0)
		}
	}, [location.pathname])

	return (
		<StatsItem
			hasHover
			deck
			loading={loading ? 1 : undefined}
			onClick={onClick}
			onMouseOver={forceCheck}
		>
			<PriceWrapper>{formatCurrency(currency, priceTotal)}</PriceWrapper>
			<StatsLabel>{t('general.price')}</StatsLabel>

			<LegalInfoFlyOut ref={ref}>
				<FlyoutDeckPrice
					deckCards={deckCards}
					deckSlug={deckSlug}
					priceSource={priceSource}
				/>
			</LegalInfoFlyOut>
		</StatsItem>
	)
}

StatsDeckPrice.propTypes = {
	deckCards: PropTypes.array.isRequired,
	deckSlug: PropTypes.string.isRequired,
	loading: PropTypes.bool.isRequired,
	location: PropTypes.object.isRequired,
	priceSource: PropTypes.number.isRequired,
	onClick: PropTypes.func,
	t: PropTypes.func.isRequired
}

StatsDeckPrice.defaultProps = {
	onClick: null
}

const PriceWrapper = styled.div`
	font-size: 1.1rem;
	margin-top: auto;

	${mobile`
		font-size: 1rem;
	`}
`

const enhance = compose(
	translate('general'),
	withRouter
)

export default enhance(StatsDeckPrice)
